<template>
  <div class="p-4">
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-col lg="12">
            <h3 class="mt-3">
              Privacy Statement and Policies That Cover Your Personal Data When
              Interacting With Us.
            </h3>

            <p class="mt-1">
              Vehicle Solutions Australia is committed to protecting the privacy
              of all individuals and organisations that we receive information
              from. We want to provide a safe and secure service to all who come
              in contact with us. We will take every step possible to ensure
              that your personal information will remain private unless
              otherwise agreed. Information that you have agreed to share will
              only be used for the purpose for which it was supplied.
            </p>
            <p class="fw-900">
              The following statements, polices and information cover;
            </p>

            <ol>
              <li>How we collect personal information.</li>
              <li>What personal information we collect.</li>
              <li>How we use this information.</li>
              <li>Who we share this information with.</li>
              <li>How we protect your information.</li>
              <li>How we would handle a data breach.</li>
              <li>How you can access your information.</li>
              <li>How to make a complaint if we can’t resolve your issue.</li>
              <li>
                Additional resources available to ensure we are complying with
                all legal requirements.
              </li>
            </ol>

            <h3 class="mt-3">How we collect Personal Information</h3>
            <p>
              We collect personal information directly from you, from other
              people and from organisations that utilise our online services.
            </p>
            <p class="fw-900">We collect personal information when you:</p>
            <ul>
              <li style="list-style: disc">
                enquire, apply for, or use one of our products or services
              </li>
              <li style="list-style: disc">
                contact us to make an enquiry or provide feedback
              </li>
              <li style="list-style: disc">visit our online services</li>
              <li style="list-style: disc">
                participate in online marketing activities or surveys
              </li>
              <li style="list-style: disc">
                talk to us or do business with us.
              </li>
            </ul>
            <p>
              While we are required to collect some types of personal
              information to meet our legal obligations, we do attempt to keep
              our collection of your personal information to what is necessary
              to offer you the products and services you require.
            </p>

            <h3 class="mt-3">
              What types of Personal Information do we collect?
            </h3>

            <p>
              Depending on the products and services, or the type of interaction
              you have with a member of our staff or a third-party provider of
              our products and services, we may collect the following types of
              personal information:
            </p>

            <ul>
              <li style="list-style: disc">
                Personal and contact details including your name, address, email
                address, phone number, and date of birth.
              </li>
              <li style="list-style: disc">
                Australian Government related identifiers and identity
                documents; Tax File Number, Medicare card, Australian passport,
                driver licence, or pension card details, Security Holder
                Reference Number (SRN) or Holder Identification Number (HIN),
                citizenship, birth, death and marriage certificates (for
                example, to verify your identity), foreign passport and driver
                licence (for example, to verify your identity at the time you
                request a product or service).
              </li>
              <li style="list-style: disc">
                Financial information; details of your employment, income,
                assets, financial liabilities, copies of bank statements and
                credit card statements from other financial institutions,
                information from third parties about your credit history and
                insurance claims history.
              </li>
              <li style="list-style: disc">
                Credit information from credit reporting agencies.
              </li>
              <li style="list-style: disc">
                Socio-demographic information; including your marital status,
                age, gender, number of dependents, occupation and nationality.
              </li>

              <li style="list-style: disc">
                Digital information; We collect information from you
                electronically when you use our online services. This includes
                information such as; location information (if enabled on your
                device), IP address, details of the device used to access our
                digital services (including mobile and tablet), details of the
                wi-fi network or mobile network used by your device, type of
                authentication used (for example touch ID or face ID.
              </li>

              <li style="list-style: disc">
                On rare occasions we may seek personal information about
                specific personal circumstances so that we can try to assist and
                support clients during any financial difficulties.
              </li>

              <li style="list-style: disc">
                Publicly available information; information that is in the
                public domain, such as from; online forums, websites, social
                media platforms and public registers (for example, those kept by
                the Australian Securities and Investments Commission).
              </li>
              <li style="list-style: disc">
                <strong
                  >Privacy of Children – Collection of Information.</strong
                >
                None of our sites or services are intended for the use of
                children, we do not knowingly collect personal information from
                children especially those under the age of 16.
              </li>
            </ul>

            <h3 class="mt-3">How do we use your information?</h3>
            <p>
              We are very careful about how we use your information in order to
              deliver all of our services. We also use your information for
              other reasons, such as to better understand you, your needs, and
              to let you know about other products and services that may
              maximise the benefits of all services we provide. For example we
              may use your information within the leasing/finance application to
              assist you in finding a vehicle at a better price, which will
              assist in reducing the cost of the finance and maximising your
              overall benefit. There are different reasons for using your
              information within our business including our related parties;
            </p>
            <p>
              <strong
                >Offering and delivering our products and services
                including:</strong
              >
            </p>
            <ul>
              <li style="list-style: disc">
                collecting, assessing and processing your application for all of
                our products and services
              </li>
              <li style="list-style: disc">
                administer and manage existing products or services you have
                with us
              </li>
              <li style="list-style: disc">
                manage our relationship with you or your employer/business
              </li>
              <li style="list-style: disc">
                improve our service to you and your experience with us
              </li>
              <li style="list-style: disc">
                communicate with you or your employer/representatives about our
                products and services
              </li>

              <li style="list-style: disc">
                let you know about our other products and services that may be
                of assistance to you.
              </li>
            </ul>

            <p>
              <strong
                >We use your information to manage our services, online
                platforms and third party relationships including to:</strong
              >
            </p>
            <ul>
              <li style="list-style: disc">
                directly deliver our products and services to you
              </li>
              <li style="list-style: disc">
                deliver and mange our products and services through third
                parties
              </li>
              <li style="list-style: disc">
                make and manage client payments and transactions
              </li>
              <li style="list-style: disc">
                collect and recover money that is owed to us
              </li>
              <li style="list-style: disc">
                respond to complaints and seek to resolve them
              </li>
            </ul>
            <p>
              <strong
                >We use your information to manage our legal responsibilities,
                including our regulatory obligations, which include the need
                to:</strong
              >
            </p>
            <ul>
              <li style="list-style: disc">confirm your identity</li>
              <li style="list-style: disc">
                share relevant information with law enforcement agencies, tax
                authorities and other regulatory bodies
              </li>
              <li style="list-style: disc">
                screen applications and monitor accounts to identify criminal
                activity such as fraud, terrorist financing, bribery, corruption
                and money laundering
              </li>
              <li style="list-style: disc">
                investigate and report financial crime.
              </li>
            </ul>

            <p>
              <strong
                >We use your information to monitor and detect internet security
                issues or unauthorised access to our online platforms
                through;</strong
              >
            </p>
            <ul>
              <li style="list-style: disc">
                detection, investigation of suspicious or fraudulent activities
              </li>
              <li style="list-style: disc">
                support and management of our information security and network
                controls to prevent cyber-attacks, unauthorised access and other
                criminal or malicious activities.
              </li>
            </ul>

            <p>
              <strong
                >We use your information for direct marketing of our products
                and services. This includes;</strong
              >
            </p>
            <ul>
              <li style="list-style: disc">
                From time to time, we may also use your personal information to
                send you information about other products and services which we
                feel may assist you further in your vehicle ownership, that we
                think may be of interest and value to you. You always have the
                option to tell us to stop all marketing material, both physical
                and digital.
              </li>
              <li style="list-style: disc">
                We may contact you by various means, including by mail,
                telephone, email, SMS or other electronic means, such as through
                social media or targeted advertising within our online platforms
                including our chat portal.
              </li>
              <li style="list-style: disc">
                <strong>Social Media Platforms.</strong> If you interact with
                one of our social media sites/marketing, share content using
                social media share buttons, or access features of the Digital
                Services that contain content or features provided by Social
                Media Platforms, the relevant Social Media Platforms may collect
                information. We encourage you to review the privacy policies of
                the Social Media Platforms that you engage with as we are not
                responsible for their privacy practices.
              </li>
              <li style="list-style: disc">
                <strong>Partners or Referral Partners.</strong> We may provide
                your information to business partners including, without
                limitation, joint marketing partners and content sponsors, for
                various purposes. For example, we may partner with a third party
                to offer products on a co-branded, co-sponsored or
                cross-promotional basis that involves the sharing of
                information. These initiatives may be offered on the Digital
                Services or on other media.
              </li>
              <li style="list-style: disc">
                <strong
                  >Advertisers, Advertising- and Marketing-Related Service
                  Providers and Partners.</strong
                >We may provide your information to advertisers, advertising
                agencies, ad networks, ad exchanges, marketing businesses,
                technology vendors and other entities that create, deliver and
                assess advertising or marketing campaigns, including
                interest-based ads.
              </li>
            </ul>

            <h3 class="mt-3">Who we share your personal data with.</h3>
            <p>
              We share your personal data with third parties that can verify the
              information you have provided when applying for one of our
              products and services, this includes;
            </p>
            <ul>
              <li style="list-style: disc">
                your employer, to verify your employment status
              </li>
              <li style="list-style: disc">
                other banks and financial institutions that you may have
                products and services with.
              </li>
              <li style="list-style: disc">
                commercially available third-party databases
              </li>
              <li style="list-style: disc">
                credit reporting bodies and credit providers.
              </li>
              <li style="list-style: disc">
                vehicle insurers to provide you with competitive insurance
                products.
              </li>
              <li style="list-style: disc">
                motor vehicle dealerships to be able to source competitive
                vehicle pricing and vehicle availability information.
              </li>
              <li style="list-style: disc">
                finance brokers to provide more competitive or appropriate
                financial solutions.
              </li>
            </ul>

            <p>
              We may share information with Authorised third parties where you
              have authorised us to do so or where we are legally required. They
              include:
            </p>
            <ul>
              <li style="list-style: disc">
                third parties that you have authorised to act for you (such as
                accountants, financial counsellors, legal representatives,
                agents, finance brokers, financial advisors, or a person with
                Power of Attorney)
              </li>
              <li style="list-style: disc">
                guarantors and other security providers.
              </li>
            </ul>

            <p>
              We may share your information between members of the the Vehicle
              Solutions Australia Group of companies in order to provide you
              with the best vehicle ownership solutions. These companies include
              Motorbuys Pty Ltd and Mogo Pty Ltd. We may share your information,
              with external parties with whom we have entered strategic alliance
              or referral arrangements to enable you to inquire about the
              services or products they offer. A product refers to any offering
              of features and benefits to a customer. This may include products
              that allow our clients to:
            </p>
            <ul>
              <li style="list-style: disc">purchase a new or used vehicle;</li>
              <li style="list-style: disc">sell a current vehicle,</li>
              <li style="list-style: disc">
                borrow money via a novated lease, chattel mortgage, consumer
                vehicle finance or a personal loan,
              </li>
              <li style="list-style: disc">
                manage (collect, hold and pay) vehicle running costs for clients
                with vehicle/s under a managed novated lease,
              </li>
            </ul>

            <h3 class="mt-3">Sending your information overseas</h3>
            <p>
              We will never knowingly send your information overseas unless;
            </p>
            <ul>
              <li style="list-style: disc">
                all or part of your employer is owned or managed by an overseas
                entity and require us to report and share information to be able
                to provide you with our products or services.
              </li>
              <li style="list-style: disc">
                we are required to do so for legal or regulatory reasons.
              </li>
              <li style="list-style: disc">
                to store data on cloud based servers such as AWS.
              </li>
            </ul>
            <p>
              If we do this, we make sure there are appropriate privacy, data
              handling and security arrangements in place to protect your
              information.
            </p>

            <h3 class="mt-3">How we keep your personal data safe.</h3>
            <p>
              Our staff are trained in how to keep your information safe and
              secure. We use secure systems and buildings to hold your
              information. We will only keep your information for as long as
              required. When we no longer need information, we take reasonable
              steps to destroy or de-identify it. We store your hard copy and
              electronic records in a secure office or through trusted third
              parties cloud based data storage. We use a range of physical,
              electronic, and other security measures to protect the security,
              confidentiality and integrity of your personal data.
            </p>
            <h3 class="mt-3">Data Breaches</h3>
            <p>
              A data breach happens when personal information is accessed,
              disclosed without authorisation, or is lost. Under the Notifiable
              Data Breaches scheme, you must be told if a data breach is likely
              to cause you serious harm.
            </p>
            <p>What is a Notifiable Data Breach?</p>
            <p>
              Under the Notifiable Data Breaches scheme, we have 30 days to
              identify, investigate and report on a data breach. We will always
              tell you if a data breach is likely to cause you serious harm.
              Examples of serious harm include:
            </p>

            <ul>
              <li style="list-style: disc">
                identity theft, which can affect your finances and credit
                report.
              </li>
              <li style="list-style: disc">financial loss through fraud</li>
              <li style="list-style: disc">
                a likely risk of physical harm, such as by an abusive ex-partner
              </li>
              <li style="list-style: disc">serious psychological harm</li>
              <li style="list-style: disc">
                serious harm to an individual’s reputation
              </li>
            </ul>
            <p>
              We will also report this breach to the Office of the Australian
              Information Commissioner.
            </p>
            <p>
              If the data breach is not likely to result in serious harm, we
              will decide in consultation with our IT team, Privacy Manager, and
              company Directors to decide if we need to disclose the
              minor/non-harmful breach to you.
            </p>

            <h3 class="mt-3">
              How we will contact you regarding a serious data breach
            </h3>
            <p>
              We may tell you about a data breach in an email, text message or
              phone call. The notification should include:
            </p>
            <ul>
              <li style="list-style: disc">
                Our full name and contact details
              </li>
              <li style="list-style: disc">
                the kinds of personal information involved in the breach
              </li>
              <li style="list-style: disc">a description of the data breach</li>
              <li style="list-style: disc">
                recommendations for the steps you can take in response
              </li>
            </ul>

            <p>
              If we are not able to contact everyone, we will put the data
              breach notification on our website. We will also take measures to
              promote this data breach notification, through our social media,
              news articles and partnership marketing/advertisements.
            </p>

            <p>
              <strong><span class="text-danger">IMPORTANT </span></strong>– If
              you think that a data breach may have affected your personal
              information and you think it may have been using one of our
              products and services, please contact us as soon as possible
              (refer to our contact details below). Please provide us with as
              much detail as possible including the types of types of
              information you believe may have been accessed.
            </p>

            <h3 class="mt-3">
              Accessing, updating, and correcting your information
            </h3>
            <p>
              You can contact us at any stage to ask to view your personal
              information/data. If your information isn’t correct or needs
              updating, you can send us a written request via email to our
              privacy officer on <strong>@vehiclesolutions.com.au</strong> to
              update/correct the information. Your request will be completed as
              soon as possible, and we will advise you once the updates or
              corrections are processed.
            </p>
            <h3 class="mt-3">Our Internet Site and the Use of Cookies</h3>
            <p>
              We may also store information about you by using cookies. Cookies
              are files which are sent by us to your computer or mobile device,
              which we can access when you visit our site in future. We do this
              to understand how users interact with our site to ensure we always
              have the best user experience.
            </p>
            <p>
              If you want to delete any cookies that are already on your
              computer, please refer to the instructions for your file
              management software to locate the file or directory that stores
              cookies. You always have the option to change your user settings
              to block cookies from our website.
            </p>
            <p>
              Please note that by deleting or blocking future cookies you may
              not be able to access certain areas or features of our site.
            </p>
            <h3 class="mt-3">Complaints and Privacy Resources</h3>
            <p>
              If you have a concern or complaint about how we have collected,
              handled, or used your personal information, please contact us on
              the details below immediately and we will do our best to rectify
              the issue.
            </p>
            <p>
              <strong
                >Vehicle Solutions Australia Privacy Officer can be contacted
                at; 1300 990 880 – 9am to 5pm Adelaide time or email
                admin@vehiclesolutions.com.au
              </strong>
              If you’re not satisfied with how we handled your complaint, you
              can lodge a dispute through the Australian Financial Complaints
              Authority (AFCA), our external dispute resolution provider. AFCA
              provides consumers and small businesses with fair, free, and
              independent dispute resolution for financial complaints.
            </p>
            <p><strong>Australian Financial Complaints Authority</strong></p>
            <p class="mb-0">Visit: www.afca.org.au</p>
            <p class="mb-0">Email: info@afca.org.au</p>
            <p class="mb-0">Phone: 1800 931 678 (free call)</p>
            <p>
              Mail: Australian Financial Complaints Authority, GPO Box 3,
              Melbourne VIC 3001
            </p>
            <p>
              You can also contact the Office of the Australian Information
              Commissioner if your complaint is about your privacy or how we
              handled your credit information.
            </p>

            <p>
              <strong>Office of the Australian Information Commissioner</strong>
            </p>
            <p class="mb-0">Visit: oaic.gov.au</p>
            <p class="mb-0">Email: enquiries@oaic.gov.au</p>
            <p class="mb-0">Phone: 1300 363 992</p>
            <p class="mb-0">Mail: GPO Box 5218, Sydney NSW 2001</p>

            <h3 class="mt-3">More Privacy Resources</h3>
            <p>
              For information on your rights and our responsibility in
              collecting and using your personal information please read;
            </p>

            <ul>
              <li style="list-style: disc">
                Australian Privacy Principles
                <a
                  href="https://www.oaic.gov.au/privacy/australian-privacy-principles"
                  target="_blank"
                >
                  - here</a
                >
              </li>
              <li style="list-style: disc">
                Australian Government Fact sheet that covers both the Privacy
                Act 1988 and the Privacy Amendment Act 2012 by clicking -
                <a
                  href="https://www.legislation.gov.au/Details/C2012A00197"
                  target="_blank"
                >
                  here</a
                >.
              </li>
              <li style="list-style: disc">
                Privacy Policy Fact sheet and requirements from the Office of
                the Australian Information Commissioner –
                <a
                  href="https://www.oaic.gov.au/about-us/our-corporate-information/key-documents/privacy-policy"
                  target="_blank"
                >
                  here</a
                >.
              </li>
              <li style="list-style: disc">
                What is a consumer data right –
                <a
                  href="https://www.oaic.gov.au/consumer-data-right/what-is-the-consumer-data-right"
                  target="_blank"
                >
                  here</a
                >.
              </li>
              <li style="list-style: disc">
                Information on specific rights involving the provision of credit
                (loans, money lending…) –
                <a
                  href="https://www.oaic.gov.au/privacy/credit-reporting"
                  target="_blank"
                >
                  here</a
                >.
              </li>

              <li style="list-style: disc">
                Data breaches – What are they and what is required by the
                organisation that has your data –
                <a
                  href="https://www.oaic.gov.au/privacy/data-breaches"
                  target="_blank"
                >
                  here</a
                >.
              </li>
              <li style="list-style: disc">
                Detailed information on internet scams –
                <a href="https://www.scamwatch.gov.au/" target="_blank"> here</a
                >.
              </li>
            </ul>

            <h3 class="mt-3">Updates to this policy</h3>
            <p>
              We will update this policy from time to time where necessary to
              reflect changes in applicable laws or in our privacy compliance
              practices. The latest version of this policy will always be
              available on our website.
            </p>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { findash } from '../../config/pluginInit'

export default {
  name: 'BlankPage',
  mounted() {
    findash.index()
  }
}
</script>
